import React from "react"
import Iframe from "react-iframe"
import { urlReps, urlBase, urlPowerBi } from "../requests/utils"

class Notif extends React.Component {
  constructor(props) {
    super(props)
    this.state = { url: null }
    this.externalFunc = this.externalFunc.bind(this)
  }

  componentDidMount() {
    var url = window.location.href,
      act = url.split("?")
    let rep = ""
    //rep = urlReps + act[1];
    if (act[1] && act[1].indexOf("RptCode") > -1) {
      let codeBase64 = act[1].split("=")[1]
      rep = atob(codeBase64)
      if (rep.indexOf("TypeReport") > -1) {
        let parametes = rep.split("&")
        let strSendParametros = ""
        let reportId = ""
        parametes.forEach((item, index) => {
          if (item.indexOf("reportId") > -1) {
            reportId += `${item}`
          } else if (
            item.indexOf("TypeReport") < 0 &&
            item.indexOf("reportId") < 0
          ) {
            strSendParametros += `${item.replace("in(", "in (")} and `
          }
        })
        strSendParametros =
          reportId +
          "&" +
          "parametersPowerBi=" +
          strSendParametros.substring(0, strSendParametros.length - 4)
        rep = `${urlBase}powerBI.aspx?urlEmbedUrl=${urlPowerBi}&${strSendParametros}`
        //console.log(strSendParametros);
      } else if (rep.indexOf("ReportExternal") > -1) {
        rep = rep
          .replace("&ReportExternal=True", "")
          .replace("&ReportExternal", "")
      } else {
        rep = urlReps + rep
      }
    }
    this.setState({ url: rep })
  }

  externalFunc = (event) => {
    const { data } = event
    if (
      data.event !== "UpdateForNewReportPageEvent" &&
      data.event !== "LoadingFinished"
    ) {
      this.setState({ url: event.data })
    }
  }

  render() {
    const { url } = this.state
    return (
      <div className="dv_notif">
        <div className="dv_header">
          <div className="dv_25 dv_left" />
          <div className="dv_50">
            <label>Reporteador Business Intelligence</label>
          </div>
          <div className="dv_25 dv_right" />
        </div>
        <div id="dv_reporte_aspx">
          <Iframe
            url={url}
            width="99%"
            height="650px"
            id="IdFrame"
            display="initial"
            position="relative"
            allowFullScreen
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-top-navigation allow-modals allow-downloads"
          />
          {/*            sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-top-navigation"
           */}
        </div>
      </div>
    )
  }
}
export default Notif
